import $ from 'jquery'
import Vue from 'vue'
import eventBus from './eventBus'

function setupPhotoGalleries(container) {
  const anchors = container.querySelectorAll('a[href^="#lightbox-"]')
  if (anchors.length) {
    anchors.forEach((anchor) => {
      const $anchor = $(anchor)
      const galleryId = $anchor.attr('href')

      $anchor.on('click', (ev) => {
        ev.preventDefault()
        ev.stopPropagation()
        eventBus.$emit('open-lightbox', galleryId)
      })
    })
  }

  const galleries = []
  if (container.matches('.cms-block-photo-gallery')) {
    galleries.push(container)
  }

  galleries.push(...container.querySelectorAll('.cms-block-photo-gallery'))
  if (galleries.length) {
    galleries.forEach((el) => {
      if (el.dataset.photoGalleryMounted) {
        return
      }

      el.dataset.photoGalleryMounted = 'true'
      new Vue({ el })
    })
  }
}

/**
 * Set up photo galleries in the container.
 *
 * @param {HTMLElement} container
 */
function setupPhotoGalleryObservers(container) {
  if (!container) {
    return
  }

  // Initialize existing elements:

  setupPhotoGalleries(container)

  // Observe new elements:

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType !== 1) {
          return
        }

        setupPhotoGalleries(node)
      })
    })
  })

  observer.observe(container, {
    childList: true,
    subtree: true,
    attributes: false,
    characterData: false,
  })
}

export { setupPhotoGalleryObservers, setupPhotoGalleries }
